import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eaf241ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "conentT" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "itemBox itemBox2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关于我们", -1))
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "itemBox" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "联系我们", -1))
const _hoisted_9 = { class: "it" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l" }, "电话", -1))
const _hoisted_11 = { class: "t" }
const _hoisted_12 = { class: "it" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l" }, "邮箱", -1))
const _hoisted_14 = { class: "t" }
const _hoisted_15 = { class: "it" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l" }, "地址", -1))
const _hoisted_17 = { class: "t" }
const _hoisted_18 = { class: "itemBox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关注我们", -1))
const _hoisted_20 = { class: "imgBox" }
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "company" }
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.footerData.about_content), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.footerData.about_phone), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.footerData.about_email), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.footerData.about_address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              class: "img",
              src: _ctx.footerData.about_wxcode,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_21),
            _createElementVNode("img", {
              class: "img",
              src: _ctx.footerData.about_wxxcx,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_22)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", {
          innerHTML: _ctx.footerData.about_beian
        }, null, 8, _hoisted_24)
      ])
    ])
  ]))
}